import { useEffect, useState } from "react"
import { Box, Chip, Grid, Typography, useTheme } from "@mui/material"
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import { useNavigate } from "react-router-dom";
import KmzService from "../../services/kmz.service";
import ModalCargarKmz from "../../modals/kmz/ModalCargarKmz";
import ModalCargarKmzFO from "../../modals/fibraOptica/ModalCargarKmzFO";

const TablaFOZonasScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const navigate = useNavigate()
    const actualizar = async() =>{
        await KmzService.obtenerZonasFO().then((resp)=>{
            setItems(resp);
        }).catch(()=>{
            navigate('/')
        })
    }

    const columns = [
        {
            name: "id_foz",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_foz",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'isDeleted_foz',
            label: "Estado",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value){
                    return <Chip label="Activo" color="success" />
                    }
                    return <Chip label="Inactivo" color="error" />
                }
            }
        },
    ];
    const onGuardar = () => actualizar();

    const onOpenEditar = () => {
        showModal(ModalCargarKmzFO, { onGuardar: onGuardar});
    };

    useEffect(() => {
        actualizar();
        document.title = `Zonas FO`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto',backgroundColor: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Zonas FO</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="Subir KMZ"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} md={6} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default TablaFOZonasScreen